export default "__VITE_ASSET__BzsG0qCL__"